import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExit = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M443.164 756.053c22.187 22.187 58.027 22.187 80.213 0l204.231-204.231c22.187-22.187 22.187-58.027 0-80.213l-204.231-204.231c-22.187-22.187-58.027-22.187-80.213 0s-22.187 58.027 0 80.213l106.951 107.52h-493.227c-31.289 0-56.889 25.6-56.889 56.889s25.6 56.889 56.889 56.889h493.227l-106.951 106.951c-22.187 22.187-21.618 58.596 0 80.213zM910.222 0h-796.444c-63.147 0-113.778 51.2-113.778 113.778v170.667c0 31.289 25.6 56.889 56.889 56.889s56.889-25.6 56.889-56.889v-113.778c0-31.289 25.6-56.889 56.889-56.889h682.667c31.289 0 56.889 25.6 56.889 56.889v682.667c0 31.289-25.6 56.889-56.889 56.889h-682.667c-31.289 0-56.889-25.6-56.889-56.889v-113.778c0-31.289-25.6-56.889-56.889-56.889s-56.889 25.6-56.889 56.889v170.667c0 62.578 51.2 113.778 113.778 113.778h796.444c62.578 0 113.778-51.2 113.778-113.778v-796.444c0-62.578-51.2-113.778-113.778-113.778z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgExit);
export default ForwardRef;
